import React, { useEffect, useState } from "react";
import './../../webcss/invoice.css';
import { invoiceDate } from './../../Utils/function';

function Invoice(props) {
    const [idata, setData] = useState(props.data);

    useEffect(() => {
        setData(props.data);
    }, [props.data]);

    if (!idata) {
        return <div className="container px-0">Loading invoice...</div>;
    }

    const getStatusClass = (status) => {
        const statusMap = {
            'PAYMENT_SUCCESS': 'text-success fw-bold',
            'PAYMENT_PENDING': 'text-warning fw-bold',
            'PAYMENT_FAILURE': 'text-danger fw-bold'
        };
        return statusMap[status] || 'text-muted fw-bold';
    };

    const displayStatus = idata.txnStatus ? (
        <span className={getStatusClass(idata.txnStatus)}>
            {idata.txnStatus.replace(/_/g, ' ')}
        </span>
    ) : (
        <span className="text-muted">Unknown</span>
    );

    return (
        <div className="container px-0 py-2" style={{ maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
            <style jsx>{`
                @media print {
                    .no-print { display: none !important; }
                    .shadow-sm { box-shadow: none !important; }
                    body { font-size: 10pt; }
                    .container { max-width: none; }
                    .card { border: 1px solid #ddd !important; background: white !important; }
                    table { font-size: 9pt; }
                    .btn { border: 1px solid #007bff !important; background: white !important; }
                }
                .compact-card { margin-bottom: 0.5rem !important; padding: 0.75rem !important; }
                .compact-text { font-size: 0.875rem; line-height: 1.2; }
                .compact-table th, .compact-table td { padding: 0.5rem !important; }
                .compact-summary { margin-bottom: 0.25rem; }
            `}</style>

            {/* Header Section */}
            <div className="row mb-2 border-bottom pb-1 compact-text">
                <div className="col-12 text-center">
                    <h5 className="text-primary mb-1 fw-bold">Payment Receipt</h5>
                    <p className="text-muted mb-0 small">Generated on {invoiceDate(new Date())}</p>
                </div>
            </div>

            {/* Customer & Transaction Details */}
            <div className="row mb-2">
                <div className="col-md-6">
                    <div className="card border-0 compact-card compact-text">
                        <h6 className="text-primary mb-2 fw-bold border-bottom pb-1">Customer Details</h6>
                        <div className="small">
                            <div className="d-flex justify-content-between mb-1">
                                <span className="text-600">Mobile No:</span>
                                <span>{idata.customerPhoneNumber || 'N/A'}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-1">
                                <span className="text-600">Category:</span>
                                <span>{idata.category || 'N/A'}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-1">
                                <span className="text-600">Status:</span>
                                {displayStatus}
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="text-600">Support:</span>
                                <span className="text-primary"><i className="fa fa-whatsapp me-1"></i> 9053119199</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card border-0 compact-card compact-text">
                        <h6 className="text-primary mb-2 fw-bold border-bottom pb-1">Transaction Details</h6>
                        <div className="small">
                            <div className="d-flex justify-content-between mb-1">
                                <span className="text-600">Order Number:</span>
                                <span>{idata.txtId || 'N/A'}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-1">
                                <span className="text-600">Transaction ID:</span>
                                <span>{idata.apiResponse?.additionalParams?.txnReferenceId || 'N/A'}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-1">
                                <span className="text-600">Biller Reference:</span>
                                <span>{idata.apiResponse?.additionalParams?.billerReferenceNumber || 'N/A'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="text-600">Date:</span>
                                <span>{invoiceDate(idata.apiRequest?.timeStamp)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Invoice Items Table */}
            <div className="card border-0 mb-2 compact-text">
                <div className="card-body p-0">
                    <table className="table table-borderless mb-0 compact-table">
                        <thead className="bg-light">
                            <tr>
                                <th className="border-0 py-2 px-3">#</th>
                                <th className="border-0 py-2 px-3 text-start">Description</th>
                                <th className="border-0 py-2 px-3 d-none d-md-table-cell">Consumer Account No.</th>
                                <th className="border-0 py-2 px-3 text-end">Amount (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-bottom">
                                <td className="py-2 px-3">1</td>
                                <td className="py-2 px-3 text-start fw-medium">{idata.billerName || 'N/A'}</td>
                                <td className="py-2 px-3 d-none d-md-table-cell">{idata.accountNumber || 'N/A'}</td>
                                <td className="py-2 px-3 text-end fw-bold text-primary">₹{parseFloat(idata.paidAmount || 0).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Summary & Totals */}
            <div className="row mb-2">
                <div className="col-md-7 compact-text">
                    <div className="text-muted small">
                        <p className="mb-0">Thank you for your payment. This receipt serves as proof of transaction.</p>
                        <p className="mb-0 mt-1"><small>For queries, contact support at 9053119199.</small></p>
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="card border-0 compact-card compact-text">
                        <h6 className="text-primary mb-2 fw-bold border-bottom pb-1">Payment Summary</h6>
                        <div className="d-flex justify-content-between mb-1 compact-summary small">
                            <span>Amount Paid</span>
                            <span className="text-primary fw-medium">₹{parseFloat(idata.paidAmount || 0).toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-1 compact-summary small text-muted">
                            <span>Payment Mode</span>
                            <span>Cash</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2 compact-summary small text-muted">
                            <span>CCF</span>
                            <span>₹0.00</span>
                        </div>
                        <hr className="my-1" />
                        <div className="d-flex justify-content-between fw-bold fs-6">
                            <span>Total Amount</span>
                            <span className="text-success">₹{parseFloat(idata.paidAmount || 0).toFixed(2)}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="row text-center border-top pt-2 compact-text">
                <div className="col-12">
                    <p className="text-muted small mb-1">
                        This is a computer-generated receipt and does not require a signature.
                    </p>
                    <button
                        onClick={() => window.print()}
                        className="btn btn-outline-primary px-3 py-1 no-print small"
                    >
                        <i className="fa fa-print me-1"></i>Print Receipt
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Invoice;